import { toSnake, toCamel } from 'change-object-case'
import { client } from 'services/client'

async function getStatistics(params) {
  const response = await client().get('/v2/corporate_connect/statistics', {
    params: toSnake(params),
  })

  return toCamel(response, { recursive: true, arrayRecursive: true })
}

export { getStatistics }
